import { render, staticRenderFns } from "./DeleteCharges.vue?vue&type=template&id=77423b1c"
import script from "./DeleteCharges.vue?vue&type=script&lang=js"
export * from "./DeleteCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports